"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bridger = Bridger;

var _plugins = require("./plugins");

function Bridger() {
  const currentWindowSingleton = window.parent || window;

  if (!currentWindowSingleton) {
    throw new Error('`Bridger` needs to be on browser context');
  } // Wrap the dispatch function for logging purposes


  const nativeDispatchFn = ({
    iframeRefs,
    action
  }) => {
    (0, _plugins.logger)('* Dispatched', action.type);

    if (iframeRefs.length) {
      iframeRefs.forEach(iframe => iframe.postMessage(action, '*'));
    }

    currentWindowSingleton.postMessage(action, '*');
  }; // A way to register callback for a given event


  const $providerSubscribe = (type, callback) => {
    currentWindowSingleton.addEventListener('message', event => {
      const action = event.data;

      if (type === action.type) {
        callback(action.payload);
      }
    }, false);
  }; // Delegates pub-sub to addEventListener


  const $consumerSubscribe = (type, callback) => {
    window.addEventListener('message', event => {
      const action = event.data;

      if (type === action.type) {
        callback(action.payload);
      }
    }, false);
  }; // Dispatch some callback with a given action


  const buildDispatchFn = (iframeRefs = []) => action => {
    if (!action.type) {
      throw new Error(`
        Actions should have this signature
        {
          type: String,
          payload?: any
        }
      `);
    }

    nativeDispatchFn({
      iframeRefs,
      action
    });
  };

  const Provider = ({
    iframeRefs = []
  } = {}) => ({
    $subscribe: $providerSubscribe,
    $dispatch: buildDispatchFn(iframeRefs)
  });

  const Consumer = () => ({
    $subscribe: $consumerSubscribe,
    $dispatch: buildDispatchFn()
  });

  return {
    Provider,
    Consumer
  };
}